/**
 * A function that always returns undefined and does nothing else.
 */
export const noop: (...args: unknown[]) => void = () => void 0
